import React from 'react';
import { useSelector } from 'react-redux';
import qs from 'qs';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MUILink from '@mui/material/Link';
import { useQuery } from 'shared/hooks';
import { ratingTypes } from 'shared/constants/ratingTypes';

const SearchBreadcrumb = () => {
  const { t } = useTranslation();
  const { companyModule = ratingTypes.CREDIT_RATING } = useQuery();

  const searchFilters = useSelector(({ searchResult }) => searchResult.searchFilters);

  const query = { ratingType: companyModule, ...searchFilters };
  const queryString = qs.stringify(query, {
    addQueryPrefix: true,
  });

  return (
    <MUILink to={`/search-result${queryString}`} color="inherit" component={Link}>
      {t('Search result')}
    </MUILink>
  );
};

export default SearchBreadcrumb;
